import * as ACTION_TYPES from './constitutionActionTypes';

export const constitutionReducerInitialState = {
	postConstitution: {
		hasError: false,
		isFetching: false,
		data: null,
		error: undefined,
	},
	getConstitution: {
		hasError: false,
		isFetching: false,
		data: null,
		error: undefined,
	},
};

export const constitutionReducer = (
	state = constitutionReducerInitialState,
	action
) => {
	switch (action.type) {
		// Post constitution actions
		case ACTION_TYPES.POST_CONSTITUTION_REQUEST: {
			return {
				...state,
				isFetching: true,
				hasError: false,
				isLoggedIn: false,
				error: undefined,
			};
		}
		case ACTION_TYPES.POST_CONSTITUTION_REQUEST_SUCCESS: {
			const { data } = action.payload;
			return {
				...state,
				postParticipation: {
					...state.postParticipation,
					isFetching: false,
					hasError: false,
					error: undefined,
					data,
				},
			};
		}

		case ACTION_TYPES.POST_CONSTITUTION_REQUEST_FAILURE: {
			const { error } = action.payload;
			return {
				...state,
				postParticipation: {
					...state.postParticipation,
					isFetching: false,
					hasError: true,
					// error
				},
			};
		}
		// END Post User actions

		// Post constitution actions
		case ACTION_TYPES.GET_CONSTITUTION_REQUEST: {
			return {
				...state,
				isFetching: true,
				hasError: false,
				isLoggedIn: false,
				error: undefined,
			};
		}
		case ACTION_TYPES.GET_CONSTITUTION_REQUEST_SUCCESS: {
			return {
				...state,
				getConstitution: {
					...state.getConstitution,
					isFetching: false,
					hasError: false,
					error: undefined,
					data: action.payload,
				},
			};
		}

		case ACTION_TYPES.GET_CONSTITUTION_REQUEST_FAILURE: {
			const { error } = action.payload;
			return {
				...state,
				getConstitution: {
					...state.getConstitution,
					isFetching: false,
					hasError: true,
					// error
				},
			};
		}
		case ACTION_TYPES.CLEAR_GET_CONSTITUTION: {
			return {
				...state,
				getConstitution: {
					hasError: false,
					isFetching: false,
					data: null,
					error: undefined,
					// error
				},
			};
		}
		// END Post User actions
		default: {
			return state;
		}
	}
};

export default constitutionReducer;

export const getConstitutionReducer = state => state.constitutionReducer;
// post
export const getPostUsersData = state =>
	getConstitutionReducer(state)?.postParticipation?.data;
export const getPostUsersIsFetching = state =>
	getConstitutionReducer(state)?.postParticipation?.isFetching;

// get
export const getConstitution = state =>
	getConstitutionReducer(state)?.getConstitution?.data;
export const getContitutionIsFetching = state =>
	getConstitutionReducer(state)?.getConstitution?.isFetching;
